'use client';

import React from 'react';

import SwipeableDrawer from '@/widgets/SwipeableDrawer';

import classes from './index.module.css';
import { GuideStep, IosPwaGuideModalProps } from './models';

import { AddSquare, Mobile, Share } from 'iconsax-react';

const STEPS: GuideStep[] = [
    {
        icon: <Share size={24} variant='Bold' color='#fff' aria-hidden />,
        title: 'دکمه اشتراک‌گذاری رو بزن',
        description: (
            <>
                این صفحه رو در <b>سافاری</b> باز کن و آیکون Share (مربع با فلش رو به بالا) در نوار پایین رو لمس کن.
            </>
        )
    },
    {
        icon: <AddSquare size={24} variant='Bold' color='#fff' aria-hidden />,
        title: '«افزودن به صفحه اصلی» رو انتخاب کن',
        description: (
            <>
                در منو کمی پایین بیا و روی <b>Add to Home Screen</b> و بعد <b>Add</b> بزن.
            </>
        )
    }
];

const IosPwaGuideModal = ({ open, onClose }: IosPwaGuideModalProps) => {
    return (
        <SwipeableDrawer open={open} onClose={onClose} title='نصب ازکی‌سرویس روی آیفون' hasCloseButton primaryActionText='فهمیدم!' onSubmit={onClose}>
            <div className={`${classes.iosGuide} flex flex-col gap-5 px-6 pb-6 pt-4 text-right`}>
                <span className={`${classes.iosIconTile} mx-auto flex h-14 w-14 items-center justify-center rounded-lg`}>
                    <Mobile size={28} variant='Bold' color='#fff' aria-hidden />
                </span>
                <ol className='m-0 flex list-none flex-col gap-4 p-0'>
                    {STEPS.map((step, index) => (
                        <li key={step.title} className='flex items-start gap-3'>
                            <span
                                className={`${step.success ? classes.iosIconTileSuccess : classes.iosIconTile} relative flex h-11 w-11 shrink-0
                                items-center justify-center rounded-lg`}>
                                {step.icon}
                                <span className={classes.iosStepNumber} aria-hidden>
                                    {index + 1}
                                </span>
                            </span>
                            <div className='flex flex-1 flex-col items-start pt-0.5 text-right'>
                                <h3 className='m-0 text-sm font-bold text-blackHighEmphasis'>{step.title}</h3>
                                <p className='m-0 mt-1 text-xs leading-5 text-blackMediumEmphasis'>{step.description}</p>
                            </div>
                        </li>
                    ))}
                </ol>
            </div>
        </SwipeableDrawer>
    );
};

export default IosPwaGuideModal;
